import React, { useEffect, useState } from 'react';

/**
 * Real end of the offer (ISO date, e.g. '2026-10-31T23:59:59+01:00').
 * While null, the bar shows a rolling 15-minute countdown.
 */
const OFFER_ENDS_AT: string | null = null;
const FALLBACK_SECONDS = 15 * 60;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
function getRemaining(fallbackStart: number): number {
  if (OFFER_ENDS_AT) {
    return Math.max(0, Math.floor((new Date(OFFER_ENDS_AT).getTime() - Date.now()) / 1000));
  }
  const elapsed = Math.floor((Date.now() - fallbackStart) / 1000);
  return FALLBACK_SECONDS - elapsed % FALLBACK_SECONDS;
}
export function CountdownBar() {
  const [start] = useState<number>(() => Date.now());
  const [remaining, setRemaining] = useState<number>(() => getRemaining(start));
  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining(start)), 1000);
    return () => window.clearInterval(id);
  }, [start]);
  if (remaining <= 0) return null;
  const days = Math.floor(remaining / 86400);
  const hours = Math.floor(remaining % 86400 / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units: Array<{
    value: number;
    suffix: string;
  }> = [...(days > 0 ? [{
    value: days,
    suffix: 'j'
  }] : []), ...(days > 0 || hours > 0 ? [{
    value: hours,
    suffix: 'h'
  }] : []), {
    value: minutes,
    suffix: 'min'
  }, {
    value: seconds,
    suffix: 's'
  }];
  return <div className="sticky top-0 z-50 w-full border-b border-white/10 bg-ink text-paper" data-id="element-32" data-mp="1r3bqrwzgscpj">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-x-3 whitespace-nowrap px-4 py-2.5 text-[13px] sm:text-sm" data-id="element-33" data-mp="1dc6n8jsz709x">
        <span className="relative flex h-2 w-2 shrink-0" aria-hidden="true" data-id="element-34" data-mp="1hcqi1gq2trsw">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-pen-soft opacity-60 motion-reduce:animate-none" data-id="element-35" data-mp="252ulno39lrjw" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-pen-soft" data-id="element-36" data-mp="29vnr6e6k53x1" />
        </span>
        <span className="text-paper/80" data-id="element-37" data-mp="2jpjitja1nsn4">
          <span className="hidden sm:inline" data-id="element-38" data-mp="2fohsjry3uqxa">L’offre spéciale se t</span>
          <span className="sm:hidden" data-id="element-39" data-mp="2fp9hijx75qel">Se t</span>ermine dans
        </span>
        <span className="flex items-baseline gap-2 font-semibold tabular-nums" aria-live="off" data-id="element-40" data-mp="2ao3jq7oojcy7">
          {units.map(unit => <span key={unit.suffix} className="flex items-baseline gap-0.5" data-id="element-41" data-mp="25q21tq2zpjob">
              <span className="text-paper" data-id="element-42" data-mp="20s8tori4mfle">{pad(unit.value)}</span>
              <span className="text-xs font-medium text-paper/60" data-id="element-43" data-mp="1w0quo8znyp32">{unit.suffix}</span>
            </span>)}
        </span>
      </div>
    </div>;
}